const opalContentValidation = /^https?:\/\/.*\/posts\/[0-9]+/i

const twitterUrlValidation = /^https?:\/\/(www\.)?(twitter\.com|x\.com).*/i

const urlValidation =
  /((https?):\/\/)?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/i

const validations = {
  opalContentValidation,
  twitterUrlValidation,
  urlValidation,
}

export { validations }
